import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../components/AccountContext';
import { useQuery } from '@apollo/react-hooks';
import { useParams } from 'react-router-dom';
import { Loading } from '../../../components/Loading';
import { growlErrors } from '../../../utils/NotificationUtil';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { SUPER_PROFILE_DETAILS_QUERY } from './services/super--profiles.service';
import { Panel } from 'primereact/panel';
import { Formik } from 'formik';
import { defineMessages, useIntl } from 'react-intl';
import useSuperProfile from './hooks/useSuperProfile';
import {
  buildSuperProfileFormInitialValues,
  buildSuperProfileFormValidationSchema,
} from './helpers/super-profiles.helper';
import SuperProfileForm from './components/SuperProfileForm';

const messages = defineMessages({
  header: {
    id: 'account.super-profiles.update.header',
    defaultMessage: 'Update SuoerProfile',
  },
});

const SUPER_PROFILE_DEFAULT_STATE = {
  id: null,
  jobProfile: {
    id: null,
  },
  workplaceDetails: {
    type: '',
    officeOnlyWorkplaceDetailsData: null,
    officeAndRemoteWorkplaceDetailsData: null,
    remoteOnlyWorkplaceDetailsData: null,
  },
  requiredLanguageProficiencies: [],
};

const UpdateSuperProfile = () => {
  const { formatMessage } = useIntl();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const { superProfileId } = useParams();

  const [superProfile, setSuperProfile] = useState(SUPER_PROFILE_DEFAULT_STATE);
  const [jobProfiles, setJobProfiles] = useState([]);
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);

  const { updateSuperProfileDetails } = useSuperProfile();
  const { loading, error, data } = useQuery(SUPER_PROFILE_DETAILS_QUERY, {
    variables: {
      accountId: currentAccount,
      superProfileId,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data && data.account && data.availableCountries && data.activeLocales) {
      setSuperProfile(data.account.superProfile);
      setJobProfiles(data.account.greatFullSpectrumJobProfiles);
      setAvailableLanguages(data.activeLocales);
      setAvailableCountries(data.availableCountries);
    }
    // eslint-disable-next-line
  }, [data]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  const initialValues = buildSuperProfileFormInitialValues(superProfile);
  const validationSchema = buildSuperProfileFormValidationSchema(superProfile);

  return (
    <div className="brand-detailed-wrapper">
      <Panel header={formatMessage(messages.header)}>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            updateSuperProfileDetails(values, superProfile.id);
          }}
        >
          <SuperProfileForm
            jobProfiles={jobProfiles}
            availableCountries={availableCountries}
            availableLanguages={availableLanguages}
          />
        </Formik>
      </Panel>
    </div>
  );
};

export default UpdateSuperProfile;
